import React, { createContext, useContext, useEffect, useState } from "react";

const ExportContext = createContext(null);

const STORAGE_KEY = "app_exports";

export const ExportProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);

  // Load from localStorage on app load
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      setJobs(JSON.parse(stored));
    }
  }, []);

  // Persist on change
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(jobs));
  }, [jobs]);

  const addJob = (job) => {
    setJobs((prev) => [...prev, job]);
  };

  const updateJob = (id, updates) => {
    setJobs((prev) =>
      prev.map((job) =>
        job.id === id ? { ...job, ...updates } : job
      )
    );
  };

  const removeJob = (id) => {
    setJobs((prev) => prev.filter((job) => job.id !== id));
  };

  const clearAllJobs = () => {
    setJobs([]);
    localStorage.removeItem(STORAGE_KEY);
  };

  return (
    <ExportContext.Provider
      value={{
        jobs,
        addJob,
        updateJob,
        removeJob,
        clearAllJobs,
      }}
    >
      {children}
    </ExportContext.Provider>
  );
};

export const useExport = () => {
  const ctx = useContext(ExportContext);
  if (!ctx) {
    throw new Error("useExport must be used inside ExportProvider");
  }
  return ctx;
};
